import { apiCall } from './_helper';

// Sends verfication code on first step of registration
// Tested and working: 4/6/2025
export const sendVerificationCode = async (email) => {
  const formData = new FormData();
  formData.append('username', email);
  return await apiCall({
    url: `registration/signup`,
    method: 'POST',
    body: formData,
    noAuth: true,
    notJSON: true,
    onError: (response) => {
      throw new Error(`Failed to send verification code: ${response.statusText}`);
    },
  });
};

// Tested and working: 4/6/2025
export const resendVerificationCode = async (email) => {
  const formData = new FormData();
  formData.append('username', email);
  return await apiCall({
    url: `registration/resendVerificationCode`,
    method: 'POST',
    body: formData,
    noAuth: true,
    notJSON: true,
    onError: (response) => {
      throw new Error(`Failed to resend verification code: ${response.statusText}`);
    },
  });
};

// Seems to not be used in the app. Untestable: 4/6/2025
export async function verifyEmailToken(token) {
  return await apiCall({
    url: `registration/verify-email`,
    method: 'POST',
    body: JSON.stringify({ token }),
    checkSessionOut: true,
    onSuccess: async (response) => {
      const result = await response.json();
      return { success: response.ok, data: result };
    },
  });
}

// Submits the company details and returns a docusign link
// Tested and working: 4/6/2025
export const submitCompanyDetails = async (formData, isSingleSignOn = false) => {
  const form = new FormData();
  Object.keys(formData).forEach(function (key) {
    if (key === 'email') {
      form.append('username', formData[key]);
    } else {
      form.append(key, formData[key]);
    }
  });
  return await apiCall({
    url: isSingleSignOn ? `registration/create360PAYCompany` : `registration/createCompany`,
    method: 'POST',
    body: form,
    noAuth: true,
    notJSON: true,
    onError: async (response) => {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to submit company details');
    },
  });
};

// Updates the database with our docusign status and sends password reset email
// Tested and working: 4/6/2025
export const approveDocusign = async (email) => {
  return await apiCall({
    url: `registration/approveDocusign?email=${encodeURIComponent(email)}`,
    noAuth: true,
    notJSON: true,
    onError: (response) => {
      throw new Error(`Failed to approve DocuSign: ${response.statusText}`);
    },
  });
};

// Returns 360pay/Transferry customer details based on an entered VAT number
export const getCompanyDetailsFromVAT = async (vatNumber) => {
  return await apiCall({
    url: `registration/verifyVAT/${encodeURIComponent(vatNumber)}`,
    noAuth: true,
    notJSON: true,
    onError: (response) => {
      throw new Error(`Failed to verify VAT: ${response.statusText}`);
    },
  });
};
